<template>
  <div>
    <server-table
      ref="table"
      :api-request="apiRequest"
      :busy.sync="table.loading"
      :columns="table.columns"
      :no-border-collapse="false"
      :sort-by.sync="table.sortBy"
      sort-desc
      responsive
      striped
      filterable
      selectable
      can-select-total
      table-class="table-sm"
      @refreshed="onRefreshed"
      @selectedItems="(i) => $emit('selected', i)"
      @selectedRows="(i) => $emit('selectedRows', i)"
      @selectedTotal="(v) => $emit('selectedTotal', v)"
      @hideFilter="resetFilter"
    >
      <div slot="beforeSearch" class="flex-grow-1">
        <h4 class="m-0">
          Meraná spotreba podružných meradiel <small>({{ count }})</small>
        </h4>
      </div>
      <template #afterSearch>
        <file-upload
          ref="upload"
          v-model="importFile"
          v-b-tooltip.hover.bottom
          :headers="{ Authorization: 'Bearer ' + getEnergyToken }"
          :post-action="importUri"
          class="btn btn-secondary ml-2"
          title="Importovať"
          @input-file="inputImport"
        >
          <b-icon icon="arrow-up-short" class="mr-n1" />
          <b-icon icon="file-earmark-spreadsheet" />
        </file-upload>
        <b-dropdown
          v-b-tooltip.hover.bottom
          class="ml-1"
          menu-class="min-w15 dropdown-menu-animated"
          right
          title="Exportovať"
          variant="outline-secondary"
        >
          <template #button-content>
            <b-icon icon="arrow-down-short" class="mr-n1" />
            <b-icon icon="file-earmark-spreadsheet" />
          </template>
          <b-dropdown-form>
            <b-form-group label="Dátum:" label-for="date" class="mb-0">
              <date-picker
                v-model="exportDate"
                class="w-100"
                opens="left"
                :append-to-body="false"
                :ranges="false"
              />
            </b-form-group>
            <b-btn variant="primary" size="sm" @click="exportMeasuring">
              Exportovať
            </b-btn>
          </b-dropdown-form>
        </b-dropdown>
        <b-dropdown
          v-if="$root.user.isAdmin"
          v-b-tooltip.hover.bottom
          class="ml-1"
          menu-class="min-w15 dropdown-menu-animated"
          right
          title="Vymazať"
          variant="outline-danger"
        >
          <template #button-content>
            <b-icon icon="trash" />
          </template>
          <b-dropdown-form>
            <b-form-group label="Dátum:" label-for="date" class="mb-0">
              <date-picker
                v-model="removeDate"
                class="w-100"
                opens="left"
                :append-to-body="false"
                :ranges="false"
              />
            </b-form-group>
            <b-btn variant="primary" size="sm" @click="removeMeasuring">
              Vymazať
            </b-btn>
          </b-dropdown-form>
        </b-dropdown>
        <!--        <b-btn
                  v-b-tooltip.hover.bottom
                  class="ml-1"
                  variant="primary"
                  title="Pridať meranie"
                  @click="openAddMeasuringModal"
                >
                  <b-icon
                    icon="plus"
                    scale="1.5x"
                  />
                </b-btn>-->
      </template>
      <template #filter>
        <b-row>
          <b-col md="4">
            <b-form-group
              label="Názov OM"
              label-for="deviceName"
              label-size="sm"
            >
              <b-input-group class="input-group-labeled">
                <b-form-input
                  v-model="table.filter['device.name']['contains']"
                  class="pr-0"
                  size="sm"
                  @keydown.enter="search"
                />
                <b-input-group-append>
                  <b-btn
                    size="sm"
                    variant="link"
                    @click="
                      table.filter['device.name']['contains'] = null
                      search()
                    "
                  >
                    <b-icon icon="x" scale="1.5x" />
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Sekcia"
              label-for="deviceSection"
              label-size="sm"
            >
              <b-input-group class="input-group-labeled">
                <b-form-input
                  v-model="table.filter['device.section']['contains']"
                  class="pr-0"
                  size="sm"
                  @keydown.enter="search"
                />
                <b-input-group-append>
                  <b-btn
                    size="sm"
                    variant="link"
                    @click="
                      table.filter['device.section']['contains'] = null
                      search()
                    "
                  >
                    <b-icon icon="x" scale="1.5x" />
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group
              label="Podlažie"
              label-for="deviceFloor"
              label-size="sm"
            >
              <b-input-group class="input-group-labeled">
                <b-form-input
                  v-model="table.filter['device.floor']['contains']"
                  class="pr-0"
                  size="sm"
                  @keydown.enter="search"
                />
                <b-input-group-append>
                  <b-btn
                    size="sm"
                    variant="link"
                    @click="
                      table.filter['device.floor']['contains'] = null
                      search()
                    "
                  >
                    <b-icon icon="x" scale="1.5x" />
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template #cell(actions)="data">
        <b-dropdown class="btn-p-0" no-caret variant="link">
          <template slot="button-content">
            <b-icon icon="text-indent-left" scale="1.25x" />
          </template>
          <b-dropdown-item @click.prevent="openAddMeasuringModal(data.item.id)">
            <b-icon class="mr-1" icon="pencil-square" />
            Upraviť
          </b-dropdown-item>
          <!--          <b-dropdown-item
                      class="text-danger"
                      @click.prevent="remove(data.item.id)"
                    >
                      <b-icon
                        class="mr-1"
                        icon="trash"
                      />
                      Vymazať
                    </b-dropdown-item>-->
        </b-dropdown>
      </template>
      <template #cell(name)="data">
        <div
          :id="`popover-${data.item.device.serialNumber}`"
          class="font-weight-bold text-primary"
        >
          {{ data.value }}
        </div>
        <b-popover
          :target="`popover-${data.item.device.serialNumber}`"
          triggers="hover"
          delay="500"
          :title="data.item.device.serialNumber"
        >
          <div class="mb-1">
            <span class="font-weight-bold">Sekcia:</span>
            {{ data.item.device.section }}
          </div>
          <div class="mb-1">
            <span class="font-weight-bold">Podlažie:</span>
            {{ data.item.device.floor }}
          </div>
          <div class="mb-1">
            <span class="font-weight-bold">Typ merania:</span>
            {{ data.item.device.measureType }}
          </div>
          <div class="mb-1">
            <div class="font-weight-bold">Poznámka:</div>
            {{ data.item.device.note }}
          </div>
          <template #title>
            <b-badge
              :variant="data.item.device.isActive ? 'primary' : 'danger'"
              class="float-right fs-sm font-weight-normal"
            >
              <template v-if="data.item.device.isActive"> Aktívne</template>
              <template v-else> Neaktívne</template>
            </b-badge>
            {{ data.item.device.serialNumber }}
            <b-btn
              v-b-tooltip.hover.bottom
              variant="link"
              size="sm"
              class="p-0 align-baseline"
              title="Upraviť meradlo"
              @click="edit(data.item.device.id)"
            >
              <b-icon icon="pencil-square" />
            </b-btn>
          </template>
        </b-popover>
      </template>
    </server-table>
    <add-measuring ref="measuringForm" />
  </div>
</template>
<script>
import ServerTable from '@/components/ServerTable'
import operationService from '@/services/api/operationService'
import apiEnergyService from '@/services/apiEnergy'
import AddMeasuring from './Add'
import FileUpload from 'vue-upload-component'
import DatePicker from '@/components/inputs/DatePicker'
import getPeriod from '../mixins/getPeriod'

export default {
  components: {
    ServerTable,
    AddMeasuring,
    FileUpload,
    DatePicker,
  },
  mixins: [getPeriod],
  data() {
    return {
      importFile: [],
      count: null,
      table: {
        loading: false,
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov OM - Koncový odb.',
            tdClass: 'name-width',
            formatter: (value, key, item) => item.device.name,
            sortable: true,
            sortableKey: 'device.name',
          },
          {
            key: 'startValue',
            label: 'Poč. stav',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 1)
                : '-',
            sortable: true,
          },
          {
            key: 'endValue',
            label: 'Kon. stav',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 1)
                : '-',
            sortable: true,
          },
          {
            key: 'consumption',
            label: 'Spotreba',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 1)
                : '-',
            sortable: true,
          },
          {
            key: 'unit',
            label: 'MJ',
            tdClass: 'text-nowrap',
          },
          {
            key: 'periodFrom',
            label: 'Od',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value ? this.$options.filters.formatDate(value) : '-',
          },
          {
            key: 'periodTo',
            label: 'Do',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value ? this.$options.filters.formatDate(value) : '-',
          },
          {
            key: 'previuousConsumption',
            label: 'Predch. spotreba',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 1)
                : '-',
          },
          {
            key: 'compareCoefficient',
            label: 'Porov. koef.',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
          },
        ],
        sortBy: 'consumption',
        filter: {
          'device.name': { contains: null },
          'device.section': { contains: null },
          'device.floor': { contains: null },
        },
      },
      exportDate: { ge: null, lt: null },
      removeDate: { ge: null, lt: null },
    }
  },
  computed: {
    importUri() {
      return `${import.meta.env.VITE_ENERGY_DATA_URL}operation/delivery-points/${this.$store.getters['operation/get'].callback_id}/device-data/import/excel`
    },
    getEnergyToken() {
      return apiEnergyService.getToken()
    },
  },
  mounted() {
    this.exportDate = {
      ge: this.period.from.ge,
      lt: this.period.to.le,
    }
    this.removeDate = {
      ge: this.period.from.ge,
      lt: this.period.to.le,
    }
    this.$root.$on('operation.reloadMeasurerData', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('operation.reloadMeasurerData')
  },
  methods: {
    edit(id) {
      this.$root.$emit('operation.openMeasurerModal', { id: id })
    },
    onRefreshed() {
      this.count = this.$refs.table.totalRows
    },
    apiRequest(params) {
      let quickSearch = {}
      if (params.query) {
        quickSearch = {
          'quickSearch[items]':
            'device.name|device.serialNumber|device.note|device.section',
          'quickSearch[term]': params.query,
        }
      }
      return operationService
        .getDeviceDataByDeliveryPointId(
          this.$store.getters['operation/get'].callback_id,
          {
            periodFrom: this.period.from,
            periodTo: this.period.to,
            orderBy: params.orderBy,
            maxResults: params.maxResults,
            startAt: params.startAt,
            ...this.table.filter,
            ...quickSearch,
          },
        )
        .then((res) => {
          res.data = {
            filtered: params.maxResults,
            total: res.headers['x-pagination-total-count']
              ? res.headers['x-pagination-total-count']
              : 0,
            rows: res.data,
          }
          return res
        })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť toto meranie?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api.post(`${id}/remove`).then((res) => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: res.data.message,
              timer: 5000,
            })
            this.fetchData()
          })
        }
      })
    },
    search() {
      this.$refs.table.search()
    },
    resetFilter() {
      Object.assign(this.table.filter, this.$options.data().table.filter)
      this.search()
    },
    openAddMeasuringModal(id = null) {
      this.$refs.measuringForm.id = id
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-measuring')
      })
    },
    inputImport(newFile, oldFile) {
      if (newFile && oldFile) {
        // Start upload
        if (newFile.active !== oldFile.active) {
          //console.log('Start upload', newFile.active, newFile)
        }

        // Upload progress
        if (newFile.progress !== oldFile.progress) {
          this.$swal({
            type: 'info',
            position: 'center',
            allowOutsideClick: false,
            text: 'Prebieha import...',
          })
        }

        // Upload error
        if (newFile.error !== oldFile.error) {
          this.$swal.close()
          this.$refs.upload.clear()
          this.$refs.table.refresh()
          this.$nextTick(() => {
            this.$swal({
              toast: true,
              type: 'error',
              position: 'top-end',
              title: 'Vyskytla sa chyba pri importovaní',
              timer: 5000,
            })
          })
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          this.$swal.close()
          this.$refs.upload.clear()
          this.$refs.table.refresh()
          this.$nextTick(() => {
            this.$swal({
              toast: true,
              type: 'success',
              position: 'top-end',
              title: 'Import prebehol úspešne',
              timer: 5000,
            })
          })
        }
      }

      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    exportMeasuring() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      operationService
        .getDeviceDataExcelExportByDeliveryPointId(
          this.$store.getters['operation/get'].callback_id,
          {
            dateFrom: this.exportDate.ge,
            dateTo: this.exportDate.lt,
          },
        )
        .then((res) => {
          //saveAs(new Blob([res.data]), 'prevadzka-merana_spotreba.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
    removeMeasuring() {
      operationService
        .deleteDeliveryPointDeviceData(
          this.$store.getters['operation/get'].callback_id,
          {
            params: {
              periodFrom: this.removeDate.ge,
              periodTo: this.removeDate.lt,
            },
          },
        )
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Meraná spotreba bola odstránená',
            timer: 5000,
          })
          this.$refs.table.refresh()
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Vyskytla sa chyba',
            timer: 5000,
          })
        })
    },
  },
}
</script>
<style>
.name-width {
  max-width: 200px;
  min-width: 150px;
}
</style>
